import { ArrowRight, Check } from 'lucide-react';
import Image from 'next/image';
import PartnerButton from './PartnerButton';
const checklist = ['Quick application', 'Monthly commission payments', 'No earning limit'];
const PartnerProgram = () => <section className="special-page-container relative z-[1] py-5 md:py-10" data-sentry-component="PartnerProgram" data-sentry-source-file="PartnerProgram.tsx">
    <div className="flex flex-col items-center gap-10 md:mx-auto md:max-w-4xl md:flex-row md:justify-between md:gap-14">
      <div className="w-full md:max-w-[514px] md:flex-1">
        <p className="mb-1 font-sans font-semibold text-pink-600 text-sm dark:text-pink-400">
          PARTNER PROGRAM
        </p>
        <h2 className="mb-1 text-pretty font-semibold text-2xl 2xl:text-3xl">
          Earn 30% commission <br className="max-md:hidden" />
          on every paid referral
        </h2>
        <p className="text-pretty font-sans text-base text-gray-700 dark:text-gray-200">
          Apply to join Uppbeat's partner program and earn recurring commission
          whenever your audience subscribes.
        </p>
        <ul className="my-6 flex list-none flex-col gap-4">
          {checklist.map(item => <li className="flex items-center gap-2 font-sans text-gray-950 text-sm dark:text-white" key={item}>
              <Check aria-hidden="true" className="size-4 shrink-0 text-pink-600 dark:text-pink-400" strokeWidth={2.5} />
              {item}
            </li>)}
        </ul>
        <PartnerButton className="w-full" fontSize="sm" size="xl" data-sentry-element="PartnerButton" data-sentry-source-file="PartnerProgram.tsx">
          Apply to become a partner
          <ArrowRight aria-hidden="true" className="size-4" data-sentry-element="ArrowRight" data-sentry-source-file="PartnerProgram.tsx" />
        </PartnerButton>
      </div>
      <div className="w-[246px] shrink-0 max-md:hidden">
        <Image alt="" className="w-full" height={196} src="/images/refer-and-earn/coin-light.svg" unoptimized width={246} data-sentry-element="Image" data-sentry-source-file="PartnerProgram.tsx" />
      </div>
    </div>
  </section>;
export default PartnerProgram;